import * as XLSX from 'xlsx';

const CO_NAME = 'Interior Point';
const CO_GSTIN = '33AAIPR0129D1Z5';
const CO_PAN = 'AAIPR0129D';
const CO_ADDR = '# 127/1A, Opp. Copper Beach Road, ECR, Akkarai, Chennai - 600 119.';

const p = v => parseFloat(v) || 0;
const fmt2 = n => Number(n || 0).toFixed(2);

const setColWidths = (ws, widths) => { ws['!cols'] = widths.map(w => ({ wch: w })); };

const addRow = (rows, vals, styles) => { rows.push(vals); return rows.length - 1; };

const buildAndSave = (rows, sheetName, fileName, merges, colWidths) => {
  const ws = XLSX.utils.aoa_to_sheet(rows);
  if (merges) ws['!merges'] = merges;
  if (colWidths) setColWidths(ws, colWidths);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, sheetName);
  XLSX.writeFile(wb, fileName);
};

/* ═══════ 1. QUOTATION ═══════ */
export const exportQuotation = (quo) => {
  const rows = [];
  const merges = [];
  let r = 0;

  // Header
  rows.push([CO_NAME]); merges.push({ s: { r, c: 0 }, e: { r, c: 6 } }); r++;
  rows.push([CO_ADDR]); merges.push({ s: { r, c: 0 }, e: { r, c: 6 } }); r++;
  rows.push(['GSTIN: ' + CO_GSTIN + '  |  PAN: ' + CO_PAN]); merges.push({ s: { r, c: 0 }, e: { r, c: 6 } }); r++;
  rows.push([]); r++;

  rows.push(['Quotation No:', quo.quo_number, '', 'Date:', quo.quo_date || '']); r++;
  rows.push(['To:', quo.client_name]); merges.push({ s: { r, c: 1 }, e: { r, c: 6 } }); r++;
  if (quo.client_address) { rows.push(['', quo.client_address]); merges.push({ s: { r, c: 1 }, e: { r, c: 6 } }); r++; }
  if (quo.attention_to) { rows.push(['Kind Attn:', quo.attention_to]); r++; }
  rows.push(['Subject:', quo.subject]); merges.push({ s: { r, c: 1 }, e: { r, c: 6 } }); r++;
  rows.push([]); r++;

  // Items header
  rows.push(['S.No', 'Description', 'Unit', 'Qty', 'Rate', 'Amount', 'Remarks']); r++;

  // Items (filter out _remark items)
  const regItems = (quo.items || []).filter(i => !i._remark);
  regItems.forEach((it, i) => {
    rows.push([it.sno || i + 1, (it.description || '').replace(/\*\*/g, ''), it.unit, p(it.qty), p(it.rate), p(it.amount), it.remarks || '']);
    r++;
  });

  rows.push([]); r++;
  const footStart = r;

  // Totals
  rows.push(['', '', '', '', 'Sub Total', p(quo.sub_total)]); r++;
  if (p(quo.discount_percent) > 0) {
    rows.push(['', '', '', '', 'Discount @' + quo.discount_percent + '%', -p(quo.discount_amount)]); r++;
  }
  rows.push(['', '', '', '', 'CGST @' + (p(quo.cgst_percent) || 9) + '%', p(quo.gst_amount) / 2]); r++;
  rows.push(['', '', '', '', 'SGST @' + (p(quo.sgst_percent) || 9) + '%', p(quo.gst_amount) / 2]); r++;
  rows.push(['', '', '', '', 'Grand Total', p(quo.grand_total)]); r++;
  if (quo.amount_in_words) { rows.push([quo.amount_in_words]); merges.push({ s: { r, c: 0 }, e: { r, c: 6 } }); r++; }

  // Terms
  rows.push([]); r++;
  rows.push(['Terms and Conditions:']); r++;
  const terms = quo.terms || ['50% advance along with purchase order.', '30% advance at 50% of work processing days.', '20% Payment after completion of work.', 'Electricity and water supply to be supply by client side.', 'Final Bill will be as per actual measurements.', 'Additional work will be cost extra.', 'GST charges extra.'];
  terms.forEach((t, i) => { rows.push([(i + 1) + '. ' + t]); merges.push({ s: { r, c: 0 }, e: { r, c: 6 } }); r++; });

  buildAndSave(rows, 'Quotation', (quo.quo_number || 'Quotation') + '.xlsx', merges, [6, 55, 7, 7, 10, 14, 14]);
};

/* ═══════ 2. DELIVERY CHALLAN ═══════ */
export const exportDeliveryChallan = (dc) => {
  const rows = [];
  const merges = [];
  let r = 0;

  rows.push([CO_NAME]); merges.push({ s: { r, c: 0 }, e: { r, c: 6 } }); r++;
  rows.push([CO_ADDR]); merges.push({ s: { r, c: 0 }, e: { r, c: 6 } }); r++;
  rows.push(['GSTIN: ' + CO_GSTIN]); merges.push({ s: { r, c: 0 }, e: { r, c: 6 } }); r++;
  rows.push([]); r++;

  rows.push(['DELIVERY CHALLAN']); merges.push({ s: { r, c: 0 }, e: { r, c: 6 } }); r++;
  rows.push([]); r++;

  rows.push(['Bill No:', dc.bill_no || '', '', 'DC Date:', dc.dc_date || '']); r++;
  if (dc.vch_no) { rows.push(['Vch No:', dc.vch_no]); r++; }
  rows.push(['To:', dc.client_name]); merges.push({ s: { r, c: 1 }, e: { r, c: 6 } }); r++;
  if (dc.client_address) { rows.push(['', dc.client_address]); merges.push({ s: { r, c: 1 }, e: { r, c: 6 } }); r++; }
  if (dc.client_gstin) { rows.push(['Client GSTIN:', dc.client_gstin]); r++; }
  if (dc.attention_to) { rows.push(['Kind Attn:', dc.attention_to]); r++; }
  if (dc.subject) { rows.push(['Subject:', dc.subject]); merges.push({ s: { r, c: 1 }, e: { r, c: 6 } }); r++; }
  rows.push([]); r++;

  rows.push(['S.No', 'Description', 'HSN', 'Unit', 'Qty', 'Rate', 'Amount']); r++;

  (dc.items || []).forEach((it, i) => {
    rows.push([i + 1, it.description, it.hsn_code || '', it.unit, p(it.qty), p(it.rate), p(it.amount)]);
    r++;
  });

  rows.push([]); r++;
  const sub = (dc.items || []).reduce((s, i) => s + p(i.amount), 0);
  rows.push(['', '', '', '', '', 'Sub Total', p(dc.sub_total) || sub]); r++;
  rows.push(['', '', '', '', '', 'CGST @9%', p(dc.cgst_amount)]); r++;
  rows.push(['', '', '', '', '', 'SGST @9%', p(dc.sgst_amount)]); r++;
  rows.push(['', '', '', '', '', 'Grand Total', p(dc.grand_total)]); r++;
  if (dc.amount_in_words) { rows.push([dc.amount_in_words]); merges.push({ s: { r, c: 0 }, e: { r, c: 6 } }); r++; }

  if (dc.contact_person || dc.contact_no) {
    rows.push([]); r++;
    rows.push(['Contact:', (dc.contact_person || '') + ' | ' + (dc.contact_no || '')]); r++;
  }

  buildAndSave(rows, 'Delivery Challan', 'DC_' + (dc.bill_no || 'Challan') + '.xlsx', merges, [10, 38, 10, 8, 8, 12, 14]);
};

/* ═══════ 3. TAX INVOICE / PROFORMA ═══════ */
export const exportTaxInvoice = (inv) => {
  const rows = [];
  const merges = [];
  let r = 0;
  const isProforma = inv.invoice_type === 'proforma';
  const title = isProforma ? 'PROFORMA INVOICE' : 'TAX INVOICE';

  rows.push([CO_NAME]); merges.push({ s: { r, c: 0 }, e: { r, c: 6 } }); r++;
  rows.push([CO_ADDR]); merges.push({ s: { r, c: 0 }, e: { r, c: 6 } }); r++;
  rows.push(['GSTIN: ' + CO_GSTIN + '  |  PAN: ' + CO_PAN]); merges.push({ s: { r, c: 0 }, e: { r, c: 6 } }); r++;
  rows.push([]); r++;

  rows.push([title]); merges.push({ s: { r, c: 0 }, e: { r, c: 6 } }); r++;
  rows.push([]); r++;

  rows.push(['Invoice No:', inv.invoice_no || '', '', 'Date:', inv.invoice_date || '']); r++;
  rows.push(['To:', inv.client_name]); merges.push({ s: { r, c: 1 }, e: { r, c: 6 } }); r++;
  if (inv.client_address) { rows.push(['', inv.client_address]); merges.push({ s: { r, c: 1 }, e: { r, c: 6 } }); r++; }
  if (inv.client_gstin) { rows.push(['Client GSTIN:', inv.client_gstin, '', 'PAN:', inv.client_pan || '']); r++; }
  if (inv.place_of_supply) { rows.push(['Place of Supply:', inv.place_of_supply]); r++; }
  if (inv.work_order_no) { rows.push(['Work Order:', inv.work_order_no, '', 'WO Date:', inv.wo_date || '']); r++; }
  rows.push([]); r++;

  rows.push(['S.No', 'Description', 'HSN', 'Unit', 'Qty', 'Rate', 'Amount']); r++;

  (inv.items || []).forEach((it, i) => {
    rows.push([i + 1, it.description, it.hsn_code || '995419', it.unit || '', p(it.qty), p(it.rate), p(it.amount)]);
    r++;
  });

  rows.push([]); r++;
  rows.push(['', '', '', '', '', 'Total', p(inv.total)]); r++;
  rows.push(['', '', '', '', '', 'CGST @' + (p(inv.cgst_rate) || 9) + '%', p(inv.cgst_amount)]); r++;
  rows.push(['', '', '', '', '', 'SGST @' + (p(inv.sgst_rate) || 9) + '%', p(inv.sgst_amount)]); r++;
  if (p(inv.round_off)) { rows.push(['', '', '', '', '', 'Round Off', p(inv.round_off)]); r++; }
  rows.push(['', '', '', '', '', 'Grand Total', p(inv.grand_total)]); r++;

  rows.push([]); r++;
  rows.push(['For ' + CO_NAME]); r++;
  rows.push(['Authorized Signature']); r++;

  buildAndSave(rows, title, (isProforma ? 'Proforma_' : 'Invoice_') + (inv.invoice_no || 'doc') + '.xlsx', merges, [12, 38, 10, 8, 8, 12, 14]);
};

/* ═══════ 4. MEASUREMENT SHEET ═══════ */
export const exportMeasurementSheet = (projectName, woNo, sheetDate, points, grandTotal) => {
  const rows = [];
  const merges = [];
  let r = 0;

  rows.push([CO_NAME]); merges.push({ s: { r, c: 0 }, e: { r, c: 4 } }); r++;
  rows.push(['Measurement Sheet']); merges.push({ s: { r, c: 0 }, e: { r, c: 4 } }); r++;
  rows.push([]); r++;

  rows.push(['Project:', projectName || '']); r++;
  rows.push(['Work Order:', woNo || '']); r++;
  rows.push(['Date:', sheetDate || '']); r++;
  rows.push([]); r++;

  rows.push(['S.No', 'Specification', 'Measurements (L x W)', 'Qty', 'Total (sqft)']); r++;

  (points || []).forEach((pt, i) => {
    const lft = p(pt.lengthFt); const lin = p(pt.lengthIn);
    const wft = p(pt.widthFt); const win = p(pt.widthIn);
    const meas = lft + "'" + lin + '" x ' + wft + "'" + win + '"';
    const qty = parseInt(pt.qty) || 1;
    const total = +((lft + lin / 12) * (wft + win / 12) * qty).toFixed(2);
    rows.push([i + 1, pt.spec || '', meas, qty, total]);
    r++;
  });

  rows.push([]); r++;
  rows.push(['', '', '', 'Grand Total', p(grandTotal)]); r++;

  const fileName = 'Measurement_' + (projectName || 'Sheet').replace(/[^a-zA-Z0-9]/g, '_') + '.xlsx';
  buildAndSave(rows, 'Measurement', fileName, merges, [8, 35, 20, 8, 14]);
};

/* ═══════ 5. CUMULATIVE BILL ═══════ */
export const exportCumulativeBill = (viewCum, cumRows, cumSubTotal, rbs) => {
  const rows = [];
  const merges = [];
  let r = 0;

  const boqItems = viewCum.boq_items || [];
  const dp = p(viewCum.discount_percent);
  const da = cumSubTotal * dp / 100;
  const ad = cumSubTotal - da;
  const cpct = p(viewCum.cgst_percent) || 9;
  const spct = p(viewCum.sgst_percent) || 9;
  const ga = ad * (cpct + spct) / 100;
  const rawGt = ad + ga;
  const gt = Math.round(rawGt);

  // Company header
  rows.push([CO_NAME]); r++;
  rows.push([CO_ADDR]); r++;
  rows.push(['PAN: ' + CO_PAN + '  |  GSTIN: ' + CO_GSTIN]); r++;
  rows.push([]); r++;

  // Doc info
  rows.push(['Bill Title:', viewCum.bill_title || '']); r++;
  rows.push(['Bill No:', viewCum.bill_number || '', '', 'Date:', viewCum.bill_date || '']); r++;
  rows.push(['Work Order:', viewCum.work_order_no || '']); r++;
  rows.push(['Client:', viewCum.client_name || '']); r++;
  if (viewCum.client_address) { rows.push(['', viewCum.client_address]); r++; }
  if (viewCum.client_gstin) { rows.push(['Client GSTIN:', viewCum.client_gstin]); r++; }
  if (viewCum.attention_to) { rows.push(['Kind Attn:', viewCum.attention_to]); r++; }
  rows.push([]); r++;

  // Dynamic columns: S.No | Description | Unit | BOQ(Qty,Rate,Amt) | RB1(Qty,Rate,Amt) | ... | Cumulative(Rate,Amt)
  const hdr1 = ['S.No', 'Description', 'Unit'];
  const hdr2 = ['', '', ''];

  // BOQ group header
  hdr1.push('As Per BOQ', '', '');
  hdr2.push('Qty', 'Rate', 'Amt');

  // RB group headers
  rbs.forEach(rb => {
    hdr1.push(rb.rb_label, '', '');
    hdr2.push('Qty', 'Rate', 'Amt');
  });

  // Cumulative group header
  hdr1.push('Cumulative', '');
  hdr2.push('Rate', 'Amt');

  rows.push(hdr1); r++;
  rows.push(hdr2); r++;

  // Merge group headers
  const totalCols = 3 + 3 + (rbs.length * 3) + 2;
  // Merge header row 1 group cells
  merges.push({ s: { r: r - 2, c: 3 }, e: { r: r - 2, c: 5 } }); // BOQ
  rbs.forEach((_, i) => {
    merges.push({ s: { r: r - 2, c: 6 + i * 3 }, e: { r: r - 2, c: 8 + i * 3 } });
  });
  merges.push({ s: { r: r - 2, c: 6 + rbs.length * 3 }, e: { r: r - 2, c: 7 + rbs.length * 3 } }); // Cumulative

  // Data rows
  cumRows.forEach((cr, i) => {
    const row = [cr.sno || i + 1, cr.description, cr.unit];
    row.push(p(cr.boq_qty), p(cr.boq_rate), p(cr.boq_amount));
    (cr.perRB || []).forEach(rb => {
      row.push(p(rb.qty), p(rb.rate), p(rb.amount));
    });
    row.push(p(cr.cumRate), p(cr.cumAmount));
    rows.push(row); r++;
  });

  // Footer
  rows.push([]); r++;
  const footLabel = (label) => { const a = new Array(totalCols).fill(''); a[totalCols - 2] = label; return a; };
  const footRow = (label, val) => { const a = footLabel(label); a[totalCols - 1] = p(val); return a; };

  rows.push(footRow('Sub-Total', cumSubTotal)); r++;
  if (dp > 0) { rows.push(footRow('Discount @' + dp + '%', -da)); r++; }
  rows.push(footRow('Total After Discount', ad)); r++;
  rows.push(footRow('CGST @' + cpct + '%', ga / 2)); r++;
  rows.push(footRow('SGST @' + spct + '%', ga / 2)); r++;
  rows.push(footRow('Round Off', gt - rawGt)); r++;
  rows.push(footRow('Grand Total', gt)); r++;

  // Column widths
  const colW = [6, 35, 8, 8, 10, 12]; // sno, desc, unit, boq qty/rate/amt
  rbs.forEach(() => { colW.push(8, 10, 12); });
  colW.push(10, 14);

  const fileName = 'Cumulative_' + (viewCum.bill_number || viewCum.bill_title || 'Bill').replace(/[^a-zA-Z0-9]/g, '_') + '.xlsx';
  buildAndSave(rows, 'Cumulative Bill', fileName, merges, colW);
};

/* ═══════ 6. PROFORMA BILL ═══════ */
export const exportProformaBill = (pb) => {
  const rows = [];
  const merges = [];
  let r = 0;

  // Header right-aligned box
  rows.push(['', '', '', '', 'Proforma Bill No: ' + (pb.quo_number || ''), '']); r++;
  rows.push(['', '', '', '', 'Date: ' + (pb.quo_date || ''), '']); r++;
  rows.push(['Work Order No: ' + (pb.work_order_no || ''), '', '', '', 'HSN Code - ' + (pb.hsn_code || '995419'), '']); r++;
  rows.push(['GSTIN No: ' + (pb.client_gstin || ''), '', '', 'GSTIN - ' + CO_GSTIN, '', '']); r++;
  rows.push([]); r++;

  // To section
  rows.push(['To']); r++;
  rows.push(['M/s. ' + (pb.client_name || '')]); merges.push({ s: { r, c: 0 }, e: { r, c: 6 } }); r++;
  if (pb.client_address) {
    const addrLines = pb.client_address.split('\n');
    addrLines.forEach(line => { rows.push([line.trim()]); merges.push({ s: { r, c: 0 }, e: { r, c: 6 } }); r++; });
  }
  rows.push([]); r++;
  if (pb.attention_to) { rows.push(['Kind Attn: ' + pb.attention_to]); merges.push({ s: { r, c: 0 }, e: { r, c: 6 } }); r++; }
  rows.push([]); r++;
  rows.push(['Sub: ' + (pb.subject || '')]); merges.push({ s: { r, c: 0 }, e: { r, c: 6 } }); r++;

  // Items header — 7 columns
  rows.push(['S.No', 'Description', 'Unit', 'Qty', 'Rate', 'Amount', 'Remarks']); r++;

  // Items (filter out _remark items)
  const regItems = (pb.items || []).filter(i => !i._remark);
  regItems.forEach((it, i) => {
    rows.push([it.sno || i + 1, (it.description || '').replace(/\*\*/g, ''), it.unit, p(it.qty) || '', p(it.rate) || '', p(it.amount) || '', it.remarks || '']);
    r++;
  });

  rows.push([]); r++;

  // Totals — 7 columns
  const sub = p(pb.sub_total);
  const discPct = p(pb.discount_percent);
  const discAmt = p(pb.discount_amount);
  const afterDisc = sub - discAmt;
  const cgstPct = p(pb.cgst_percent) || 9;
  const sgstPct = p(pb.sgst_percent) || 9;
  const cgst = afterDisc * cgstPct / 100;
  const sgst = afterDisc * sgstPct / 100;
  const rawGt = afterDisc + cgst + sgst;
  const gt = Math.round(rawGt);
  const roff = +(gt - rawGt).toFixed(2);

  rows.push(['', '', '', '', '', 'Sub - Total', sub]); r++;
  if (discPct > 0) {
    rows.push(['', '', '', '', '', 'Discount @ ' + discPct + '%', discAmt]); r++;
    rows.push(['', '', '', '', '', 'Total', afterDisc]); r++;
  }
  rows.push(['', '', '', '', '', 'CGST @ ' + cgstPct + '%', cgst]); r++;
  rows.push(['', '', '', '', '', 'SGST @ ' + sgstPct + '%', sgst]); r++;
  rows.push(['', '', '', '', '', 'Total GST', cgst + sgst]); r++;
  rows.push(['', '', '', '', '', 'R/Off', roff]); r++;
  rows.push(['', '', '', '', '', 'Grand Total', gt]); r++;

  if (pb.amount_in_words) { rows.push([pb.amount_in_words]); merges.push({ s: { r, c: 0 }, e: { r, c: 6 } }); r++; }
  rows.push([]); r++;
  rows.push(['Thanks & Regards']); r++;
  rows.push([]); r++;
  rows.push([CO_NAME]); r++;

  buildAndSave(rows, 'Proforma Bill', 'PB_' + (pb.quo_number || 'Bill').replace(/[^a-zA-Z0-9]/g, '_') + '.xlsx', merges, [6, 55, 7, 7, 10, 14, 14]);
};
